import { render, staticRenderFns } from "./TaskDelayListModal.vue?vue&type=template&id=027f894b&scoped=true"
import script from "./TaskDelayListModal.vue?vue&type=script&lang=js"
export * from "./TaskDelayListModal.vue?vue&type=script&lang=js"
import style0 from "./TaskDelayListModal.vue?vue&type=style&index=0&id=027f894b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027f894b",
  null
  
)

export default component.exports